const guideGen4 = [
  "Zweiblattdorf – Starter-Pokémon erhalten",
  "Route 201 – Pokémon fangen & Training",
  "Sandgemme – Pokédex bekommen",
  "Route 202 – Erstes Trainerduell",
  "Jubelstadt – Pokétch erhalten",
  "Route 203 – Rivalenkampf",
  "Erzelingen – 1. Arena (Gestein – Veit)",
  "Route 207 – Zugang aber kein Fortschritt",
  "Route 204 & Erhebungshöhle – zurück nach Jubelstadt",
  "Route 203 – Richtung Ewigenau",
  "Ewigenau – 2. Arena (Pflanze – Lamina)",
  "Galaktik-Gebäude räumen",
  "Rad erhalten & Radweg freischalten",
  "Route 206 – Radweg hinunter",
  "Route 207 & 208 – zu Herzhofen",
  "Herzhofen – 3. Arena (Geist – Fantina)",
  "Route 209 & Turm der Ruhenden",
  "Schleiede – 4. Arena (Kampf – Hilda)",
  "Galaktik-Gebäude östlich räumen",
  "Route 214 & Trostu – Geisterhaus",
  "Weideburg – 5. Arena (Wasser – Amalias Vater)",
  "Sumpf & Team Galaktik bekämpfen",
  "Route 212 – Sümpfe & Itemsuche",
  "Zurück nach Herzhofen",
  "Route 210 – Nebel & Ninja-Trainer",
  "Route 215 – nach Schleiede",
  "Route 216 & 217 – Schneepassagen",
  "Blizzach – 6. Arena (Eis – Frida)",
  "Route 218 – nach Fleetburg",
  "Fleetburg – 7. Arena (Stahl – Adam)",
  "Route 222 – zur Pokémon Liga",
  "Sonnewik – 8. Arena (Elektro – Volkner)",
  "Route 223 – zur Pokémon Liga",
  "Siegesstraße & Elite 4",
  "Pokémon Liga – Top 4 & Champ Cynthia",
];

export default guideGen4;
